import { Component, OnInit, ViewChild  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabComponent } from '@syncfusion/ej2-angular-navigations';
import { AuthenService } from '../../services/authen.service';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Query, DataManager, ODataV4Adaptor  } from '@syncfusion/ej2-data';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { MyDataAdaptor } from '../../helpers/grid.adaptor';
import * as AppConst from '../../data/test.data';
import { ReportParaFilter } from '../../models/report/report-para-filter.model';
import { CustListString } from '../../models/report/cust-list-string.model';
import { DatePipe } from '@angular/common';
import { MultiSelectCust } from '../../models/report/multi-select-cust.model';
import { GridComponent, ToolbarItems, ExcelExportProperties  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { NotifyService } from '../../services/notify.service';
import { TranslateService } from '@ngx-translate/core';
import { SidebarService } from '../../sidebar/sidebar.service';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { debug } from 'util';
import { saveAs as importedSaveAs } from "file-saver";


@Component({
    selector: '',
    templateUrl: './report.quota.phasing.monthly.html'
})
export class ReportQuotaPhasingMonthly implements OnInit {

    public data: object[];
    public userLogin: string = '';
    public show: boolean = false;

    //statusReport: Array<any> = ['All', 'Open', 'Waiting for principal approve', 'Principal approved', 'Waiting tender result', 'Win', 'Lost', 'Cancel'];
    //Area: Array<any> = ['All', 'HCM', 'HN', 'SOU', 'NOR', 'MEK', 'CEN'];
    //Detail: Array<any> = ['All', 'Tender', 'Renewal', 'Tender supplement', 'Price Application', 'Apply tender result', 'Direct purchase tender'];

    public lstPrnStr: string = '';
    statusReport: Array<any> = [];
    Area: Array<any> = [];
    Detail: Array<any> = [];
    PhasingPeriod: Array<any> = ['12', '24', '36'];
    dateFormat = "dd/MM/yyyy";
    public dateValueFrom: Date = new Date();
    public statusReportSelected: string = '';
    public areaSelected: string = '';
    public detailSelected: string = '';
    public empListPRN: Array<any> = [];
    public strFromYear: string = '';
    public strFromMonth: string = '';
    public dataPRN: Array<string> = [];
    reportParaFilter = new ReportParaFilter();
    public placeholder: string = 'Select Principal';
    public dataReport: DataManager;
    public toolbarOptions: ToolbarItems[];
    @ViewChild('grid') public grid: GridComponent;

    //Autocomplete Ref no
    public dataAutocompleteRefNo: DataManager;
    public textAutocompleteRefNo: string = "Find a Ref No";
    public textRefNoSelected: string = "";

    //radio date
    public dateCreateOrEffect: string = "";
    public strPhasingPeriod: string = "";
    public strReportType: string = "";
    public valueRadio: string = '';

    constructor(private http: HttpService, private helper: HelperService, private datePipe: DatePipe, private auth: AuthenService) {
        this.getPrnByUser();
    }

    ngOnInit(): void  { 
    }

    //report 4  begin+++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    getPrnByUser() {
        debugger     
        if (this.auth.isZPV) {
            this.userLogin = this.auth.LoginUser;
            this.http.get('api/Report/GetPRN/' + this.userLogin, res => {
                this.dataPRN = res;
                if (this.dataPRN) {
                    this.http.get('api/Report/GetListRefNoByPrincipal/All', res => {
                        this.dataAutocompleteRefNo = res;
                    }, null);
                }
            }, null);
            this.dataPRN.push('All');
        }
        else {
            this.userLogin = this.auth.LoginUser;
            this.http.get('api/Report/GetPRN/' + this.userLogin, res => {
                this.dataPRN = res;
                if (this.dataPRN) {
                    this.getRef(this.dataPRN);
                }
            }, null);

        }

        this.http.get('api/Report/GetVS_Area/', res => {
            this.Area = res;
        }, null);

        this.http.get('api/Report/Get_VS_TenderStatus/', res => {
            this.statusReport = res;
        }, null);

        this.http.get('api/Report/Get_VS_TenderDetail/', res => {
            this.Detail = res;
        }, null);
    }

    getRef(arr_names: string[]) {
        if (arr_names) {
            debugger
            var str1 = 'api/Report/GetListRefNoByPrincipal/';
            var str2 = arr_names.join();
            var strURL = str1.concat(str2);

            this.http.get(strURL, res => {
                this.dataAutocompleteRefNo = res;
            }, null);
        }
    }

    changePhasingPeriod(event) {
        this.strPhasingPeriod = event.value;
        console.log(this.strPhasingPeriod);
    }

    //report 4  end-----------------------------------------------------------

    //onItemChange(event) {
    //    this.dateCreateOrEffect = event;
    //    this.strReportType = event.value;
    //    console.log(this.dateCreateOrEffect);
    //    console.log(this.strReportType);
    //}

    onChangedProdMode(mode: number) {
        this.strReportType = String(mode);
    }

    onFiltering(event) {
        this.empListPRN.push(event.value);
    }

    changeStatusReport(ev) {
        this.statusReportSelected = ev.value;
    }
    changeAreaReport(ev) {
        this.areaSelected = ev.value;
    }

    changeDetialReport(ev) {
        this.detailSelected = ev.value;
    }

    convertDateToString() {
        if (!this.statusReportSelected || 0 === this.statusReportSelected.length) {
            this.statusReportSelected = 'All';
        }

        if (!this.areaSelected || 0 === this.areaSelected.length) {
            this.areaSelected = 'All';
        }

        if (!this.detailSelected || 0 === this.detailSelected.length) {
            this.detailSelected = 'All';
        }

        if (!this.empListPRN || 0 === this.empListPRN.length) {
            //this.lstPrnStr = 'All';
            //this.lstPrnStr = String(this.dataPRN[0]);
            if (this.auth.isZPV) {
                this.lstPrnStr = 'All';
            }
            else {
                this.lstPrnStr = String(this.dataPRN[0]);
            }
        }
        else {
            this.lstPrnStr = this.empListPRN.join(";");
        }

        if (!this.strReportType || 0 === this.strReportType.length) {
            this.strReportType = '1';
        }
        if (!this.textRefNoSelected || 0 === this.textRefNoSelected.length) {
            this.textRefNoSelected = 'All';
        }
        if (!this.strPhasingPeriod || 0 === this.strPhasingPeriod.length) {
            this.strPhasingPeriod = '12';
        }
  
        let fromDate = this.datePipe.transform(this.dateValueFrom, 'yyyyMMdd');
        this.strFromYear = fromDate.substring(0, 4);
        this.strFromMonth = fromDate.substring(4, 6);

        this.reportParaFilter.FromMonth = this.strFromMonth;
        this.reportParaFilter.FromYear = this.strFromYear;
        this.reportParaFilter.Status = this.statusReportSelected;
        this.reportParaFilter.Area = this.areaSelected;
        this.reportParaFilter.Principal = this.lstPrnStr;
        //this.reportParaFilter.CustCode = this.textCustSelected;
        //this.reportParaFilter.ItemCode = this.textItemSelected;
    }

    onExportClick() {
        var element = <HTMLInputElement>document.getElementById("btnExcel");
        element.disabled = true;
        this.convertDateToString();
        let fromDate = this.datePipe.transform(this.dateValueFrom, 'yyyyMMdd');
                
        this.show = true;
        this.http.download(`api/Report/ExportVS_ReportByQuotaPhasingMonthly12to36?FromMonth=${this.reportParaFilter.FromMonth}&FromYear=${this.reportParaFilter.FromYear}&Status=${this.reportParaFilter.Status}&Area=${this.reportParaFilter.Area}&Principal=${this.reportParaFilter.Principal}&ReportType=${this.strReportType}&appType=${this.detailSelected}&requestCode=${this.textRefNoSelected}&PhasingPeriod=${this.strPhasingPeriod.toString()}&fromDate=${fromDate}&fromDate2=${this.datePipe.transform(this.dateValueFrom, 'yyyy-MM-dd')}`, res => {
            importedSaveAs(res, "Quota Phasing Monthly.xlsx");
            this.show = false;
            element.disabled = false;
        });

        //grid view
        //this.dataReport = new DataManager({ url: `${this.http.baseUrl}api/Report/GetPageReportByQuotaPhasingMonthly?FromMonth=${this.reportParaFilter.FromMonth}&FromYear=${this.reportParaFilter.FromYear}&Status=${this.reportParaFilter.Status}&Area=${this.reportParaFilter.Area}&Principal=${this.reportParaFilter.Principal}&ReportType=${this.strReportType.toString()}&appType=${this.detailSelected}&requestCode=${this.textRefNoSelected}&PhasingPeriod=${this.strPhasingPeriod.toString()}&fromDate=${fromDate}`, adaptor: new MyDataAdaptor(this.helper), crossDomain: true });

    }

    onChangedRefNo(e) {
        debugger
        if (e.item) {
            this.textRefNoSelected = e.itemData;
        } else {
            this.textRefNoSelected = "";
        };
    }



}
